const SERVICE_OPTIONS = [
  { value: '', label: 'All Services' },
  { value: 'medication-review', label: 'Medication Review' },
  { value: 'flu-vaccination', label: 'Flu Vaccination' },
  { value: 'blood-pressure', label: 'Blood Pressure Check' },
  { value: 'smoking-support', label: 'Smoking Cessation Support' }
]

function PatientsFilterBar({ filters, onFilterChange, patientCount, onAddPatient, onSendEmail, selectedCount }) {
  const handleMinAgeChange = (e) => {
    const value = e.target.value === '' ? null : parseInt(e.target.value, 10)
    onFilterChange({ ...filters, minAge: value })
  }

  const handleMaxAgeChange = (e) => {
    const value = e.target.value === '' ? null : parseInt(e.target.value, 10)
    onFilterChange({ ...filters, maxAge: value })
  }

  const handleServiceChange = (e) => {
    onFilterChange({ ...filters, service: e.target.value || null })
  }

  const handlePresetClick = (minAge) => {
    onFilterChange({ ...filters, minAge, maxAge: null })
  }

  const handleClearFilters = () => {
    onFilterChange({ minAge: null, maxAge: null, service: null })
  }

  const hasFilters = filters.minAge || filters.maxAge || filters.service

  return (
    <div className="patients-filter-bar">
      <div className="filter-row">
        <div className="filter-group">
          <label>Age Range</label>
          <div className="age-inputs">
            <input
              type="number"
              placeholder="Min"
              value={filters.minAge || ''}
              onChange={handleMinAgeChange}
              min="0"
              max="120"
              className="age-input"
            />
            <span className="age-separator">to</span>
            <input
              type="number"
              placeholder="Max"
              value={filters.maxAge || ''}
              onChange={handleMaxAgeChange}
              min="0"
              max="120"
              className="age-input"
            />
          </div>
          <div className="preset-buttons">
            <button
              type="button"
              className={`preset-button ${filters.minAge === 40 && !filters.maxAge ? 'active' : ''}`}
              onClick={() => handlePresetClick(40)}
            >
              40+
            </button>
            <button
              type="button"
              className={`preset-button ${filters.minAge === 65 && !filters.maxAge ? 'active' : ''}`}
              onClick={() => handlePresetClick(65)}
            >
              65+
            </button>
          </div>
        </div>

        <div className="filter-group">
          <label>Service</label>
          <select
            value={filters.service || ''}
            onChange={handleServiceChange}
            className="service-select"
          >
            {SERVICE_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        {hasFilters && (
          <button
            type="button"
            className="clear-filters-button"
            onClick={handleClearFilters}
          >
            Clear Filters
          </button>
        )}
      </div>

      <div className="action-row">
        <p className="patient-count">
          Showing {patientCount} patient{patientCount !== 1 ? 's' : ''}
          {selectedCount > 0 && ` (${selectedCount} selected)`}
        </p>
        <div className="action-buttons">
          <button
            type="button"
            className="button outline"
            onClick={onAddPatient}
          >
            + Add Patient
          </button>
          <button
            type="button"
            className="button primary"
            onClick={onSendEmail}
            disabled={selectedCount === 0}
          >
            Send Email{selectedCount > 0 ? ` (${selectedCount})` : ''}
          </button>
        </div>
      </div>
    </div>
  )
}

export default PatientsFilterBar
